import React, { useEffect, useState } from "react";
import { fetchPublicBanners, trackBannerClick } from "@/lib/ads";
import { publicAssetUrl } from "@/lib/api";

/** Rotating banner carousel for HOME_TOP / HOME_INLINE placements. */
export function PublicBannerSlot({ placement = "HOME_TOP", districtSlug, className = "" }) {
    const [banners, setBanners] = useState([]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        fetchPublicBanners({ placement, district_slug: districtSlug || undefined, limit: 5 })
            .then((list) => setBanners(Array.isArray(list) ? list : []))
            .catch(() => setBanners([]));
    }, [placement, districtSlug]);

    useEffect(() => {
        if (banners.length <= 1) return;
        const t = setInterval(() => setIndex((i) => (i + 1) % banners.length), 5000);
        return () => clearInterval(t);
    }, [banners.length]);

    if (!banners.length) return null;
    const b = banners[index];

    const handleClick = async (e) => {
        // Fire-and-forget click tracking, then follow the CTA.
        trackBannerClick(b.id);
        if (!b.cta_url) {
            e.preventDefault();
            return;
        }
    };

    const inner = (
        <div
            className={`relative overflow-hidden rounded-2xl bg-neutral-100 ${className}`}
            data-testid={`public-banner-${placement}`}
        >
            <img
                src={publicAssetUrl(b.image_url)}
                alt={b.title}
                className="h-full w-full object-cover transition-opacity duration-500"
                onError={(e) => { e.currentTarget.style.background = "linear-gradient(135deg, #f97316, #f59e0b)"; }}
            />
            <div className="absolute right-2 top-2 rounded-full bg-black/40 px-2 py-0.5 text-[10px] font-semibold text-white backdrop-blur">
                Ad
            </div>
            {banners.length > 1 && (
                <div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 gap-1">
                    {banners.map((_, i) => (
                        <span
                            key={i}
                            className={`h-1.5 w-1.5 rounded-full ${i === index ? "bg-white" : "bg-white/40"}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );

    if (b.cta_url) {
        const isExternal = /^https?:\/\//.test(b.cta_url);
        return isExternal ? (
            <a href={b.cta_url} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="block">
                {inner}
            </a>
        ) : (
            <a href={b.cta_url} onClick={handleClick} className="block">
                {inner}
            </a>
        );
    }
    return inner;
}

export default PublicBannerSlot;
